import { useMemo } from "react";
import { WORLDS_EVENTS } from "~utils/data/state";
import { useGeolocation, useProductFlag } from "~utils/hooks/meta";
import { useEventInvitation } from "~utils/hooks/share";
import { useCurrentEvent } from "~utils/hooks/state";
import { Info, Warning } from "./Warning";

export const OfflineNotice: React.FC = () => {
	const { data: event } = useCurrentEvent();
	const { data: invitation } = useEventInvitation(event?.sku);
	const { error } = useGeolocation({
		staleTime: 0,
		refetchOnMount: true,
		refetchOnReconnect: true,
	});

	if (!error) {
		return null;
	}

	if (!invitation) {
		return null;
	}

	return (
		<Info message="Offline Mode" className="mt-4">
			Referee FYI will continue to work normally, even when you are offline.
			When you reconnect, you will sync back up with your existing instance.
		</Info>
	);
};

export const DisconnectedWarning: React.FC = () => {
	const productMode = useProductFlag("mode");
	const { data: event } = useCurrentEvent();
	const { data: invitation } = useEventInvitation(event?.sku);
	const isSharing = useMemo(
		() => !!invitation && invitation.accepted,
		[invitation],
	);

	return productMode === "WC" &&
		!isSharing &&
		WORLDS_EVENTS.includes(event?.sku ?? "") ? (
		<Warning message="Disconnected from Shared Instance." />
	) : null;
};
